module.exports = __webpack_public_path__ + "img/UpperTeeth.4e37c013.png";